import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase and services
const app = initializeApp(firebaseConfig);

// Initialize services with proper error handling
const initializeFirebaseServices = () => {
  try {
    const auth = getAuth(app);
    const db = getFirestore(app);
    const storage = getStorage(app);
    const realtimeDb = getDatabase(app);
    const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

    return { auth, db, storage, realtimeDb, analytics };
  } catch (error) {
    console.error('Error initializing Firebase services:', error);
    throw error;
  }
};

// Export initialized services
const services = initializeFirebaseServices();
export const { auth, db, storage, realtimeDb, analytics } = services;

// Export app for FCM and other services
export { app };
